import { START_FEN } from '../fen.js';
import type { RuleSet } from './types.js';

const FIFTY_MOVES_IN_PLIES = 100;
const THREEFOLD = 3;
// FIDE's automatic (unclaimed) draws: Article 9.6.
const SEVENTY_FIVE_MOVES_IN_PLIES = 150;
const FIVEFOLD = 5;

/**
 * Standard chess. Threefold repetition and the 50-move rule end the game
 * automatically rather than on a claim — the casual-play convention, which
 * saves a "claim draw" control nobody would know to press.
 */
export const FIDE: RuleSet = {
  id: 'fide',
  startFen: START_FEN,
  fiftyMovePlies: FIFTY_MOVES_IN_PLIES,
  repetitionLimit: THREEFOLD,
};

/**
 * Limits for replaying a recorded game (PGN import). Over the board,
 * threefold and the 50-move rule are only claimable, and real games often
 * play on past them — so a replay draws only where FIDE does so
 * automatically: fivefold repetition and 75 moves.
 */
export function withReplayLimits(rules: RuleSet): RuleSet {
  return {
    ...rules,
    repetitionLimit: Math.max(rules.repetitionLimit, FIVEFOLD),
    fiftyMovePlies: Math.max(rules.fiftyMovePlies, SEVENTY_FIVE_MOVES_IN_PLIES),
  };
}
